import { useTranslation } from 'react-i18next';
import type { Delivery, Supplier } from '@interfaces/ILogistics';
import { supplierById } from '@d-orca/shared/client/logistics';
import { StarFilledIcon } from '@components/Pages/IssuesPage/Board/icons';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import { BoardCardPreview } from '../panels/BoardCard';
import { cargoLabel } from './calendar.labels';
import type { CalendarMode } from './calendar.logic';
import { toneStyle } from '../deliveryTone';
import styles from './CalendarChip.module.css';

interface ICalendarChipProps {
  delivery: Delivery;
  /** The order's color: its status, or lateness. */
  tone: string;
  suppliers: Supplier[];
  tz: string;
  /** A month chip is one line; a week chip wraps. */
  mode: CalendarMode;
  onOpen: () => void;
}

/** One order on the calendar, previewing its card on hover and opening its drawer on click. */
export function CalendarChip({ delivery, tone, suppliers, tz, mode, onOpen }: ICalendarChipProps) {
  const { t } = useTranslation();
  return (
    <Tooltip
      variant="card"
      side="bottom"
      content={<BoardCardPreview delivery={delivery} tz={tz} now={new Date()} supplierName={supplierById(suppliers, delivery.supplierId)?.name} onHover />}
    >
      <button type="button" className={styles.chip} data-mode={mode} style={toneStyle(tone)} onClick={onOpen}>
        {delivery.isCritical ? <span className={styles.star}><StarFilledIcon size={11} /></span> : null}
        <span className={styles.text}><b>#{delivery.ref}</b> {cargoLabel(delivery, t)}</span>
      </button>
    </Tooltip>
  );
}
